//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { PadlockUnlockedLargeSVG } from './svg'

interface PadlockUnlockedLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const PadlockUnlockedLargeIcon: React.FC<PadlockUnlockedLargeIconProps> = forwardRef<
  PadlockUnlockedLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={PadlockUnlockedLargeSVG}
    sx={sx}
  />
))
